import MyCourses from './screens/MyCourses';
import CourseSubjectCalif from './screens/CourseSubjectCalif';
import StudentSubjectPage from './screens/StudentSubjectPage';
import CourseSubjectPage from './screens/CourseSubjectPage';
import CourseSubjectNotebook from './screens/CourseSubjectNotebook';

const routes = [
  {
    path: "/my-courses/:course_subject_id/notebook",
    exact: true,
    component: CourseSubjectNotebook,
    layout: "/admin",
    sidebar: false,
    roleID: 'TEACHER'
  },
  {
    path: "/my-courses/:course_subject_id/calif/:student_id",
    exact: true,
    component: StudentSubjectPage,
    layout: "/admin",
    sidebar: false,
    roleID: 'TEACHER'
  },{
    path: "/my-courses/:course_subject_id/calif",
    exact: true,
    name: "Mis cursos",
    icon: "fa fa-book",
    component: CourseSubjectCalif, 
    layout: "/admin",
    sidebar: false,
    roleID: 'TEACHER'
  },
  {
    path: "/my-courses/:course_subject_id",
    exact: true,
    component: CourseSubjectPage,
    layout: "/admin",
    sidebar: false,
    roleID: 'TEACHER'
  },
  {
    path: "/my-courses",
    exact: true,
    name: "Mis cursos",
    icon: "fa fa-book",
    component: MyCourses,
    layout: "/admin",
    sidebar: true,
    roleID: 'TEACHER'
  }

]
  
export default routes;